import React from 'react';

import {BrowserRouter, Link, Route, Switch} from 'react-router-dom';
import Form from './Component/form';
import Main from './Component/main';

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/"><Main/></Route>
        <Route path="/con"><Form/></Route>
        <Route exact path="/github" render={() => (window.location = "https://www.github.com/karanpatel2329")} />
        <Route exact path="/facebook" render={() => (window.location = "https://www.facebook.com/karanpatel2329")} />
        <Route exact path="/instagram" render={() => (window.location = "https://www.instagram.com/karanpatel2329")} />
        <Route exact path="/linkedin" render={() => (window.location = "https://www.linkedin.com/in/karanpatel2329")} />
   
      </Switch>
    </BrowserRouter> 
  );
}

export default App;
